import { CheckoutRequest } from '../../models/checkout/checkout-request.interface';
import { mockCheckoutCustomerDetails } from '../checkout-customer/checkout-customer-details.mock';
import { mockCheckoutDirectDebitPaymentDetails } from '../checkout-payment/checkout-direct-debit-payment-details.mock';

export const mockCheckoutRequest: CheckoutRequest = {
  basketId: 'basketId',
  customer: mockCheckoutCustomerDetails,
  items: [],
  payment: mockCheckoutDirectDebitPaymentDetails,
};
